import { MDBAlert, MDBBtn, MDBIcon, MDBModalFooter } from 'mdb-react-ui-kit';
import React, { forwardRef } from 'react'
import { useTranslation } from 'react-i18next';

const DeleteLunaExternalNumber = forwardRef((props, ref) => {
    const { t, i18n } = useTranslation();

    async function removeThisNumber() {
        props.setdeleteFlag(true);
    }

    return (
        <>
            <div className="d-flex align-items-center bg-danger bg-opacity-25 p-3  rounded-3 square border border-2 border-danger">
                <MDBIcon fas icon="ban" className="me-3" size="lg" color="danger" />
                <span>{t("RemoveUserExtrnalNumbertxt")}</span>
            </div>
            {/* <div>
                <span className="phrecording">{t("RemoveUserExtrnalNumbertxt")}</span>
            </div> */}
            <div style={{ display: "none" }}>
                <button ref={ref} onClick={(e) => removeThisNumber(e)}>
                    {t("remove")}</button>
            </div>


        </>
    )
});


export default DeleteLunaExternalNumber
